import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
// redux
import {
  fetchAllEmailGroupList,
  deleteEmailGroup,
} from "../../../../../store/emailGroup";
// kendo
import { Loader } from "@progress/kendo-react-indicators";
// component
import { TableHeader } from "../../../../../components/table/Tableheader";
import { EmailGroupTableBody } from "../../../../../components/table/emailGroupTable";
import { SearchEmailGroup } from "../../../../../components/dialog/email_group_search";
import { FilterEmailGroup } from "../../../../../components/dialog/email_group_filter";
// routes
import {
  ADMIN_TOOLS_EMAIL_GROUP_LIST,
  ADMIN_TOOLS_EMAIL_GROUP_ADD,
} from "../../../../../routes";
// permissions
import {
  getUserPermission,
  checkMultiPermission,
} from "../../../../../config/permission_helper";
import {
  ADMIN_TOOLS_FOB_ADD_EDIT_EMAIL_GROUP,
  ADMIN_TOOLS_FOB_DELETE_EMAIL_GROUP,
} from "../../../../../config/permission_helper";

export const EmailGroupList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  // redux
  const { email_groups_loading, email_groups, delete_email_group_loading } =
    useSelector((state) => state.emailGroup);
  // states
  const [loading, setLoading] = useState(false);
  const [allEmailGroups, setAllEmailGroups] = useState([]);
  const [filteredEmailGroups, setFilteredEmailGroups] = useState([]);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showSearchDialog, setShowSearchDialog] = useState(false);

  // methods
  const shouldHideAddButton = () => {
    const userPermissions = getUserPermission();
    return checkMultiPermission(
      userPermissions,
      ADMIN_TOOLS_FOB_ADD_EDIT_EMAIL_GROUP
    )
      ? false
      : true;
  };

  const shouldShowDeleteButton = () => {
    const userPermissions = getUserPermission();
    return checkMultiPermission(userPermissions, ADMIN_TOOLS_FOB_DELETE_EMAIL_GROUP)
      ? true
      : false;
  };

  const handleFilteringData = () => {
    let results = allEmailGroups;
    if (query.get("type")) {
      results = results.filter(
        (v) =>
          v.type.toLowerCase().indexOf(query.get("type").toLowerCase()) > -1
      );
    }
    if (query.get("name")) {
      results = results.filter(
        (v) =>
          v.name.toLowerCase().indexOf(query.get("name").toLowerCase()) > -1
      );
    }
    if (query.get("user")) {
      let all_users = query.get("user").split(",");
      if (all_users.indexOf("All") === -1) {
        results = results.filter((v) => {
          let all_user_names = v.user_list.map((x) => x.name);
          return all_user_names.filter((x) => all_users.includes(x)).length > 0;
        });
      }
    }
    setFilteredEmailGroups(results);
  };

  const handleSearchCallback = (data) => {
    console.log(data);
    const { name, type } = data;
    query.set("name", name);
    query.set("type", type);
    if (name || type) {
      query.set("search", true);
    }
    navigate(ADMIN_TOOLS_EMAIL_GROUP_LIST + "?" + query.toString());
    setShowSearchDialog(false);
    handleFilteringData();
  };

  const handleFilterCallback = (data) => {
    console.log("handleFilterCallback:", data);
    const { user } = data;
    query.set("user", user.toString());

    if (user.length > 0) {
      query.set("filter", true);
    }
    navigate(ADMIN_TOOLS_EMAIL_GROUP_LIST + "?" + query.toString());
    setShowFilterDialog(false);
    handleFilteringData();
  };

  const handleDeleteAction = (id) => {
    setLoading(true);
    dispatch(deleteEmailGroup(id)).then((r) => {
      dispatch(fetchAllEmailGroupList()).then((res) => {
        let results = res.payload;
        setAllEmailGroups(results);
        setLoading(false);
      });
    });
  };

  // useEffect
  useEffect(() => {
    let results = allEmailGroups;
    if (query.toString()) {
      if (query.get("name")) {
        results = results.filter(
          (v) =>
            v.name.toLowerCase().indexOf(query.get("name").toLowerCase()) > -1
        );
      }
      if (query.get("type")) {
        results = results.filter(
          (v) =>
            v.type.toLowerCase().indexOf(query.get("type").toLowerCase()) > -1
        );
      }
      if (query.get("user")) {
        let all_users = query.get("user").split(",");
        if (all_users.indexOf("All") === -1) {
          results = results.filter((v) => {
            let all_user_names = v.user_list.map((x) => x.name);
            return (
              all_user_names.filter((x) => all_users.includes(x)).length > 0
            );
          });
        }
      }
    }
    setFilteredEmailGroups(results);
    setLoading(false);
  }, [allEmailGroups]);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchAllEmailGroupList()).then((res) => {
      let results = res.payload;
      setAllEmailGroups(results);
      console.log("useEffect results:", results);
    });
  }, []);

  return (
    <div className="admin-tool-email-group-list-content">
      {showFilterDialog && (
        <FilterEmailGroup
          setShowFilterDialog={setShowFilterDialog}
          onFiltercallback={handleFilterCallback}
        />
      )}
      {showSearchDialog && (
        <SearchEmailGroup
          setShowSearchDialog={setShowSearchDialog}
          onSearchcallback={handleSearchCallback}
        />
      )}
      <TableHeader
        title="Manage Email Groups"
        onRefresh={() => {
          dispatch(fetchAllEmailGroupList()).then((res) => {
            let results = res.payload;
            setAllEmailGroups(results);
          });
        }}
        hideaddbtn={shouldHideAddButton()}
        loading={loading}
        onFilter={() => setShowFilterDialog(true)}
        onSearch={() => setShowSearchDialog(true)}
        addurl={ADMIN_TOOLS_EMAIL_GROUP_ADD}
      />
      {email_groups_loading || loading || delete_email_group_loading ? (
        <Loader
          type="infinite-spinner"
          style={{
            display: "flex",
            alignItems: "center",
            width: "40px",
            margin: "auto",
            justifyContent: "center",
            height: "100vh",
          }}
        />
      ) : (
        <EmailGroupTableBody
          data={filteredEmailGroups}
          handleDeleteAction={handleDeleteAction}
          showDeleteOption={shouldShowDeleteButton()}
        />
      )}
    </div>
  );
};
